module.exports = __webpack_public_path__ + "static/img/1048.cd0f56f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/1048.png
// module id = SFn8
// module chunks = 0